import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './loading-chart.module.css';

export function LoadingChart() {
    return (
        <LoadingIcon className={styles['loading-icon']} size={40} style={{height: 40, width: 40}} />
    );
}
